import axios from 'axios';
import { DataService } from './dataService';
import { Storage } from '../Storage/Storage';

const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;

const CourierModeChargeService = {
    list: (params) => DataService.get('/admin/courier_mode_charges', params),
    save: (data) => DataService.post('/admin/courier_mode_charges', data),
    remove: (data) => DataService.delete('/admin/courier_mode_charges', data),
    importFile: (formData) => {
        const auth = Storage.get('auth');
        return axios.post(REACT_APP_API_BASEURL + '/admin/courier_mode_charges/import', formData, {
            headers: {
                Authorization: auth && auth.authToken ? auth.authToken : '',
            },
        }).then((response) => response.data).catch((error) => (
            error.response && error.response.data
                ? error.response.data
                : { status: false, message: 'Upload failed' }
        ));
    },
    exportRemote: (params) => DataService.get('/admin/courier_mode_charges/export', params),
};

export default CourierModeChargeService;
